// Histórico de atendimentos (inclui os importados da planilha) + exportação Excel.
import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  Button, Chip, MenuItem, Paper, Table, TableBody, TableCell, TableHead, TablePagination,
  TableRow, TextField, makeStyles,
} from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetApp";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import Title from "../../components/Title";
import suporteApi, { baixar, mensagemErro } from "../api";
import { DialogCard, SITUACAO, dataBR } from "../comum";

const useStyles = makeStyles((theme) => ({
  papel: { flex: 1, overflowY: "auto", ...theme.scrollbarStyles },
  filtros: { display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" },
  linha: { cursor: "pointer" },
  mono: { fontFamily: "monospace", fontSize: 12 },
}));

const POR_PAGINA = 50;

const Historico = () => {
  const c = useStyles();
  const [filtros, setFiltros] = useState({ busca: "", status: "", de: "", ate: "" });
  const [aplicados, setAplicados] = useState(filtros);
  const [pagina, setPagina] = useState(0);
  const [dados, setDados] = useState({ itens: [], total: 0 });
  const [aberto, setAberto] = useState(null);

  const params = useCallback(
    () => Object.fromEntries(Object.entries(aplicados).filter(([, v]) => v !== "")),
    [aplicados]
  );

  const carregar = useCallback(async () => {
    try {
      const { data } = await suporteApi.get("/api/atendimentos/historico", {
        params: { ...params(), pagina: pagina + 1, por_pagina: POR_PAGINA },
      });
      setDados(data);
    } catch (err) {
      toast.error(mensagemErro(err));
    }
  }, [params, pagina]);

  useEffect(() => {
    carregar();
  }, [carregar]);

  const buscar = (e) => {
    e.preventDefault();
    setPagina(0);
    setAplicados(filtros);
  };
  const campo = (nome) => ({
    value: filtros[nome], onChange: (e) => setFiltros({ ...filtros, [nome]: e.target.value }), size: "small",
  });

  return (
    <MainContainer>
      <MainHeader>
        <Title>Histórico de atendimentos</Title>
        <MainHeaderButtonsWrapper>
          <form className={c.filtros} onSubmit={buscar}>
            <TextField placeholder="O.S, conta, filial, técnico, protocolo…" style={{ minWidth: 260 }} {...campo("busca")} />
            <TextField select label="Situação" style={{ minWidth: 140 }} {...campo("status")}>
              <MenuItem value="">Todas</MenuItem>
              <MenuItem value="ABERTO">Em andamento</MenuItem>
              <MenuItem value="PENDENTE">Pendentes</MenuItem>
              <MenuItem value="FECHADO">Concluídos</MenuItem>
            </TextField>
            <TextField label="De" type="date" InputLabelProps={{ shrink: true }} {...campo("de")} />
            <TextField label="Até" type="date" InputLabelProps={{ shrink: true }} {...campo("ate")} />
            <Button type="submit" variant="contained" color="primary">Buscar</Button>
            <Button startIcon={<GetAppIcon />} onClick={() =>
              baixar("/api/exportar/atendimentos.xlsx", params()).catch((err) => toast.error(mensagemErro(err)))}>
              Excel
            </Button>
          </form>
        </MainHeaderButtonsWrapper>
      </MainHeader>
      <Paper className={c.papel} variant="outlined">
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Início</TableCell><TableCell>Situação</TableCell><TableCell>O.S</TableCell>
              <TableCell>Filial</TableCell><TableCell>Técnico</TableCell><TableCell>Serviço</TableCell>
              <TableCell>Causa / solução</TableCell><TableCell>Analista</TableCell><TableCell>Protocolo</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dados.itens.map((a) => (
              <TableRow key={a.id} hover className={c.linha} onClick={() => setAberto(a.id)}>
                <TableCell>{dataBR(a.inicio)}</TableCell>
                <TableCell>
                  <Chip size="small" label={SITUACAO[a.status] || a.status}
                    color={a.status === "ABERTO" ? "primary" : a.status === "PENDENTE" ? "secondary" : "default"} />
                </TableCell>
                <TableCell>{a.categoria === "interno" ? <i>Interno</i> : a.os}</TableCell>
                <TableCell>{a.filial || a.solicitante || a.conta}</TableCell>
                <TableCell>{`${a.qra ?? ""} ${a.tecnico || ""}`}</TableCell>
                <TableCell>{a.categoria === "interno" ? a.titulo : `${a.tipo || ""} / ${a.sistema || ""}`}</TableCell>
                <TableCell>{a.causa || "—"}</TableCell>
                <TableCell>{a.analista_fim || a.analista}</TableCell>
                <TableCell className={c.mono}>{a.protocolo || a.protocolo_legado}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
      <TablePagination
        component="div" count={dados.total} page={pagina} rowsPerPage={POR_PAGINA}
        rowsPerPageOptions={[POR_PAGINA]} onChangePage={(e, p) => setPagina(p)}
        labelDisplayedRows={({ from, to, count }) => `${from}–${to} de ${count.toLocaleString("pt-BR")}`}
      />
      <DialogCard id={aberto} open={!!aberto} onClose={() => { setAberto(null); carregar(); }} />
    </MainContainer>
  );
};

export default Historico;
